/* eslint-disable max-len */

import React from 'react';

function CoinsIcon() {
  return (
    <svg
      width="38"
      height="31"
      viewBox="0 0 38 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M30.6976 17.5096L30.692 20.7036C30.692 19.2885 29.7634 17.8677 27.8951 16.7937C26.9721 16.2568 25.8981 15.8596 24.757 15.5911C21.3336 14.7911 17.2613 15.1883 14.498 16.7937C12.6744 17.8565 11.7571 19.2495 11.7515 20.6479L11.7627 17.4539C11.7683 16.0609 12.6801 14.6682 14.5092 13.6055C17.2725 12 21.3448 11.5971 24.7682 12.3971C25.9093 12.6656 26.9777 13.0682 27.9063 13.5997C29.769 14.6794 30.7032 16.0945 30.6976 17.5096Z"
        fill="#F2BC36"
      />
      <path
        d="M30.6983 17.509L30.6892 20.7009C30.6853 22.0971 29.7694 23.4911 27.9397 24.5544L27.9487 21.3625C29.7785 20.2992 30.6943 18.9052 30.6983 17.509Z"
        fill="#F9C73A"
      />
      <path
        d="M11.7537 20.6489L11.7627 17.457C11.7587 18.8708 12.6896 20.2867 14.5533 21.3628C18.2604 23.5031 24.2693 23.5031 27.9488 21.3649L27.9398 24.5567C24.2603 26.695 18.2514 26.695 14.5442 24.5547C12.6805 23.4786 11.7497 22.0627 11.7537 20.6489Z"
        fill="#F9C73A"
      />
      <path
        d="M27.9046 14.4513C31.6118 16.5917 31.6315 20.0722 27.9483 22.2126C24.2688 24.3509 18.2599 24.3509 14.5528 22.2106C10.8492 20.0723 10.8295 16.5918 14.509 14.4535C18.1922 12.313 24.201 12.3131 27.9046 14.4513Z"
        fill="#F9C73A"
      />
      <path
        d="M33.5 17.5198L33.491 20.7116C33.4859 22.5197 32.2982 24.3249 29.9255 25.7038C25.1497 28.4792 17.3786 28.4771 12.5715 25.7017C10.1525 24.3051 8.94429 22.4719 8.94948 20.6416L8.95853 17.4497C8.95334 19.28 10.1615 21.1132 12.5805 22.5098C17.3877 25.2852 25.1587 25.2873 29.9345 22.5119C32.3072 21.1331 33.4949 19.3278 33.5 17.5198Z"
        fill="#F2BC36"
      />
      <path
        d="M29.8781 12.4547C34.6852 15.2301 34.7105 19.7336 29.9345 22.5091C25.1587 25.2845 17.3877 25.2824 12.5805 22.507C7.7734 19.7316 7.74799 15.2324 12.5238 12.457C17.2998 9.68147 25.071 9.67934 29.8781 12.4547ZM14.5533 21.3605C18.2605 23.5009 24.2693 23.5009 27.9488 21.3626C31.632 19.2222 31.6123 15.7416 27.9051 13.6013C24.2016 11.463 18.1927 11.463 14.5095 13.6034C10.83 15.7417 10.8497 19.2223 14.5533 21.3605Z"
        fill="#FED44C"
      />
      <path
        d="M25.8467 15.2832L25.8448 15.9411L25.3276 16.2416L25.3295 15.5837L25.8467 15.2832Z"
        fill="#F2BC36"
      />
      <path
        d="M21.4485 16.8343L21.4503 16.1764C21.4508 16.0233 21.5631 15.8831 21.7845 15.7544C22.0122 15.6221 22.2892 15.5626 22.6128 15.5745C22.9391 15.5849 23.2682 15.6712 23.6005 15.8333L23.5986 16.4912C23.2664 16.3291 22.9372 16.2428 22.611 16.2324C22.2874 16.2205 22.0104 16.28 21.7826 16.4123C21.5612 16.541 21.4489 16.6812 21.4485 16.8343Z"
        fill="#F2BC36"
      />
      <path
        d="M24.224 16.2239L24.2221 16.8818L22.3176 17.9886L22.3195 17.3307L24.224 16.2239Z"
        fill="#F2BC36"
      />
      <path
        d="M25.0964 17.4065L25.0945 18.0644C24.9635 17.6211 24.6711 17.2269 24.2224 16.8818L24.2243 16.2239C24.673 16.569 24.9654 16.9632 25.0964 17.4065Z"
        fill="#F2BC36"
      />
      <path
        d="M26.6925 17.2488L26.6906 17.9067L25.0942 18.0644L25.0961 17.4064L26.6925 17.2488Z"
        fill="#F2BC36"
      />
      <path
        d="M19.6216 16.7294L19.6235 16.0715C19.6233 16.1076 19.6262 16.1439 19.6321 16.1804C19.6908 16.5582 20.0144 17.0239 20.6003 17.5728L20.5985 18.2307C20.0125 17.6818 19.6889 17.2162 19.6303 16.8383C19.6244 16.8018 19.6215 16.7655 19.6216 16.7294Z"
        fill="#F2BC36"
      />
      <path
        d="M21.5295 18.7848L21.5276 19.4427C21.5276 19.435 21.5274 19.4272 21.5268 19.4195C21.5157 19.2528 21.3654 19.0148 21.0786 18.7099L21.0805 18.052C21.3673 18.3569 21.5176 18.5949 21.5287 18.7616C21.5292 18.7693 21.5295 18.7771 21.5295 18.7848Z"
        fill="#F2BC36"
      />
      <path
        d="M21.0806 18.052L21.0787 18.7099L19.2537 19.7705L19.2555 19.1126L21.0806 18.052Z"
        fill="#F2BC36"
      />
      <path
        d="M17.526 19.3624L17.5241 20.0203C16.6862 19.4268 16.2199 18.7306 16.1204 17.9289L16.1222 17.271C16.2218 18.0727 16.688 18.7689 17.526 19.3624Z"
        fill="#F2BC36"
      />
      <path
        d="M17.4407 20.1657L17.4388 20.8236L16.7844 20.4457L16.7863 19.7878L17.4407 20.1657Z"
        fill="#F2BC36"
      />
      <path
        d="M18.1701 19.7446L18.1682 20.4025L17.4387 20.8265L17.4406 20.1686L18.1701 19.7446Z"
        fill="#F2BC36"
      />
      <path
        d="M23.3395 18.8823L23.3377 19.5402C23.3367 19.8927 23.0667 20.2244 22.5296 20.5365C21.9358 20.8816 21.2432 21.0394 20.4521 21.0126C19.6584 20.9843 18.8971 20.779 18.1682 20.3997L18.1701 19.7418C18.899 20.1211 19.6603 20.3264 20.454 20.3546C21.245 20.3815 21.9377 20.2237 22.5315 19.8786C23.0686 19.5665 23.3385 19.2348 23.3395 18.8823Z"
        fill="#F2BC36"
      />
      <path
        d="M23.3318 18.7768C23.3905 19.1695 23.1229 19.5369 22.5316 19.8805C21.9378 20.2256 21.2452 20.3834 20.4541 20.3565C19.6604 20.3283 18.8991 20.123 18.1702 19.7437L17.4407 20.1676L16.7863 19.7898L17.5261 19.3599C16.6881 18.7664 16.2219 18.0702 16.1223 17.2685L17.75 17.1852C17.828 17.8025 18.121 18.3127 18.6318 18.7173L20.6002 17.5734C20.0142 17.0245 19.6906 16.5589 19.632 16.181C19.5708 15.8017 19.8332 15.4433 20.4194 15.1026C21.0031 14.7634 21.6853 14.6027 22.4686 14.6251C23.2545 14.6459 23.9926 14.8378 24.6856 15.1993L25.1924 14.9047L25.8469 15.2825L25.3297 15.5831C26.0231 16.0457 26.4782 16.602 26.6925 17.2506L25.0961 17.4082C24.9651 16.965 24.6727 16.5708 24.224 16.2256L22.3195 17.3324L22.3504 17.3503C22.9468 17.9081 23.2782 18.3841 23.3318 18.7768ZM20.3152 19.3956C20.6619 19.415 20.9518 19.357 21.1898 19.2186C21.4253 19.0818 21.5401 18.9285 21.5288 18.762C21.5177 18.5953 21.3674 18.3573 21.0806 18.0524L19.2555 19.113C19.616 19.2825 19.9684 19.3763 20.3152 19.3956ZM21.8468 16.849L23.6003 15.83C23.268 15.6679 22.9388 15.5816 22.6126 15.5712C22.289 15.5593 22.012 15.6188 21.7842 15.7511C21.5589 15.882 21.4467 16.0249 21.4502 16.181C21.4562 16.3358 21.5858 16.5589 21.8468 16.849Z"
        fill="#FED44C"
      />
      <path
        d="M31.7898 13.0587L31.7842 16.2527C31.7842 14.8376 30.8557 13.4168 28.9874 12.3428C28.0644 11.8058 26.9904 11.4087 25.8493 11.1402C22.4259 10.3402 18.3536 10.7373 15.5903 12.3428C13.7667 13.4056 12.8494 14.7986 12.8438 16.197L12.855 13.003C12.8606 11.61 13.7723 10.2173 15.6015 9.15452C18.3648 7.54905 22.4371 7.14617 25.8605 7.94618C27.0016 8.21467 28.07 8.61727 28.9986 9.14878C30.8613 10.2285 31.7954 11.6436 31.7898 13.0587Z"
        fill="#F2BC36"
      />
      <path
        d="M31.7908 13.0569L31.7818 16.2488C31.7778 17.6449 30.8619 19.039 29.0322 20.1023L29.0413 16.9104C30.871 15.8471 31.7869 14.453 31.7908 13.0569Z"
        fill="#F9C73A"
      />
      <path
        d="M12.8462 16.195L12.8552 13.0032C12.8512 14.4169 13.7821 15.8329 15.6458 16.9089C19.353 19.0492 25.3618 19.0493 29.0413 16.911L29.0323 20.1029C25.3528 22.2412 19.3439 22.2411 15.6368 20.1008C13.773 19.0247 12.8422 17.6088 12.8462 16.195Z"
        fill="#F9C73A"
      />
      <path
        d="M28.9971 9.99894C32.7043 12.1393 32.724 15.6198 29.0408 17.7603C25.3613 19.8985 19.3525 19.8985 15.6453 17.7582C11.9418 15.6199 11.9221 12.1394 15.6016 10.0011C19.2847 7.86065 25.2936 7.86069 28.9971 9.99894Z"
        fill="#F9C73A"
      />
      <path
        d="M34.5923 13.0625L34.5833 16.2544C34.5782 18.0624 33.3905 19.8677 31.0178 21.2465C26.242 24.0219 18.4709 24.0198 13.6638 21.2444C11.2447 19.8478 10.0366 18.0146 10.0418 16.1843L10.0508 12.9924C10.0456 14.8228 11.2538 16.6559 13.6728 18.0525C18.48 20.828 26.251 20.83 31.0268 18.0546C33.3995 16.6758 34.5872 14.8705 34.5923 13.0625Z"
        fill="#F2BC36"
      />
      <path
        d="M30.9704 8.00259C35.7775 10.778 35.8028 15.2814 31.0268 18.0569C26.251 20.8323 18.48 20.8302 13.6728 18.0548C8.86568 15.2794 8.84028 10.7802 13.6161 8.00482C18.3921 5.22931 26.1633 5.2272 30.9704 8.00259ZM15.6456 16.9084C19.3527 19.0487 25.3616 19.0488 29.0411 16.9105C32.7243 14.77 32.7046 11.2895 28.9974 9.14916C25.2939 7.0109 19.285 7.01087 15.6018 9.15129C11.9223 11.2896 11.942 14.7701 15.6456 16.9084Z"
        fill="#FED44C"
      />
      <path
        d="M26.9394 10.8225L26.9376 11.4804L26.4204 11.781L26.4223 11.1231L26.9394 10.8225Z"
        fill="#F2BC36"
      />
      <path
        d="M22.541 12.3736L22.5429 11.7157C22.5433 11.5626 22.6556 11.4224 22.877 11.2937C23.1048 11.1614 23.3818 11.1019 23.7054 11.1138C24.0316 11.1242 24.3607 11.2105 24.693 11.3726L24.6912 12.0305C24.3589 11.8684 24.0297 11.7821 23.7035 11.7717C23.3799 11.7598 23.1029 11.8193 22.8751 11.9516C22.6537 12.0803 22.5415 12.2205 22.541 12.3736Z"
        fill="#F2BC36"
      />
      <path
        d="M25.3165 11.7651L25.3147 12.423L23.4102 13.5298L23.412 12.8719L25.3165 11.7651Z"
        fill="#F2BC36"
      />
      <path
        d="M26.1886 12.9477L26.1868 13.6056C26.0558 13.1624 25.7634 12.7682 25.3147 12.423L25.3166 11.7651C25.7653 12.1103 26.0577 12.5045 26.1886 12.9477Z"
        fill="#F2BC36"
      />
      <path
        d="M27.7853 12.7893L27.7834 13.4472L26.187 13.6049L26.1889 12.947L27.7853 12.7893Z"
        fill="#F2BC36"
      />
      <path
        d="M20.7144 12.2707L20.7162 11.6128C20.7161 11.6489 20.719 11.6852 20.7249 11.7217C20.7835 12.0995 21.1071 12.5651 21.6931 13.1141L21.6913 13.772C21.1053 13.223 20.7817 12.7574 20.723 12.3796C20.7172 12.3431 20.7143 12.3068 20.7144 12.2707Z"
        fill="#F2BC36"
      />
      <path
        d="M22.6222 14.326L22.6204 14.9839C22.6204 14.9762 22.6201 14.9685 22.6196 14.9607C22.6085 14.7941 22.4582 14.5561 22.1714 14.2512L22.1733 13.5933C22.4601 13.8982 22.6103 14.1362 22.6215 14.3028C22.622 14.3106 22.6223 14.3183 22.6222 14.326Z"
        fill="#F2BC36"
      />
      <path
        d="M22.1734 13.5933L22.1715 14.2512L20.3464 15.3118L20.3483 14.6539L22.1734 13.5933Z"
        fill="#F2BC36"
      />
      <path
        d="M18.6188 14.8988L18.6169 15.5567C17.7789 14.9632 17.3127 14.267 17.2131 13.4653L17.215 12.8074C17.3146 13.6091 17.7808 14.3053 18.6188 14.8988Z"
        fill="#F2BC36"
      />
      <path
        d="M18.5335 15.7094L18.5316 16.3673L17.8772 15.9894L17.8791 15.3315L18.5335 15.7094Z"
        fill="#F2BC36"
      />
      <path
        d="M19.2629 15.2839L19.261 15.9418L18.5315 16.3658L18.5334 15.7079L19.2629 15.2839Z"
        fill="#F2BC36"
      />
      <path
        d="M24.4323 14.425L24.4304 15.083C24.4295 15.4354 24.1595 15.7671 23.6224 16.0793C23.0285 16.4244 22.3359 16.5821 21.5449 16.5553C20.7512 16.527 19.9899 16.3218 19.261 15.9424L19.2629 15.2845C19.9917 15.6639 20.753 15.8691 21.5468 15.8974C22.3378 15.9242 23.0304 15.7665 23.6242 15.4214C24.1613 15.1093 24.4313 14.7775 24.4323 14.425Z"
        fill="#F2BC36"
      />
      <path
        d="M24.4243 14.3161C24.483 14.7088 24.2155 15.0762 23.6241 15.4198C23.0303 15.7649 22.3377 15.9227 21.5467 15.8959C20.7529 15.8676 19.9916 15.6623 19.2628 15.283L18.5332 15.707L17.8788 15.3291L18.6186 14.8992C17.7806 14.3057 17.3144 13.6095 17.2148 12.8078L18.8425 12.7245C18.9205 13.3418 19.2136 13.852 19.7243 14.2566L21.6927 13.1127C21.1067 12.5638 20.7831 12.0982 20.7245 11.7204C20.6633 11.3411 20.9257 10.9826 21.5119 10.6419C22.0956 10.3027 22.7778 10.142 23.5611 10.1644C24.3471 10.1852 25.0852 10.3771 25.7781 10.7386L26.285 10.444L26.9394 10.8218L26.4222 11.1224C27.1157 11.585 27.5707 12.1413 27.785 12.7899L26.1886 12.9475C26.0576 12.5043 25.7652 12.1101 25.3165 11.7649L23.412 12.8717L23.4429 12.8896C24.0393 13.4474 24.3708 13.9234 24.4243 14.3161ZM21.4077 14.9349C21.7544 14.9543 22.0443 14.8963 22.2823 14.7579C22.5179 14.6211 22.6326 14.4679 22.6213 14.3013C22.6102 14.1346 22.4599 13.8966 22.1731 13.5917L20.3481 14.6523C20.7086 14.8219 21.0609 14.9156 21.4077 14.9349ZM22.9394 12.3883L24.6928 11.3693C24.3605 11.2072 24.0313 11.1209 23.7051 11.1105C23.3815 11.0986 23.1045 11.1581 22.8767 11.2904C22.6515 11.4213 22.5392 11.5642 22.5427 11.7204C22.5487 11.8751 22.6783 12.0982 22.9394 12.3883Z"
        fill="#FED44C"
      />
      <path
        d="M34.8597 7.69443L34.8541 10.8885C34.8541 9.47335 33.9255 8.05251 32.0572 6.97855C31.1342 6.44157 30.0602 6.04444 28.9191 5.77595C25.4957 4.97594 21.4235 5.37308 18.6601 6.97855C16.8366 8.04131 15.9192 9.4343 15.9136 10.8327L15.9248 7.63871C15.9304 6.24574 16.8422 4.85303 18.6713 3.79026C21.4346 2.18479 25.5069 1.78191 28.9303 2.58192C30.0714 2.85041 31.1398 3.25301 32.0684 3.78452C33.9311 4.86422 34.8653 6.27933 34.8597 7.69443Z"
        fill="#F2BC36"
      />
      <path
        d="M34.8602 7.69263L34.8511 10.8845C34.8472 12.2807 33.9313 13.6747 32.1016 14.738L32.1106 11.5461C33.9403 10.4828 34.8562 9.08879 34.8602 7.69263Z"
        fill="#F9C73A"
      />
      <path
        d="M15.9158 10.8305L15.9248 7.63867C15.9208 9.05243 16.8517 10.4684 18.7154 11.5444C22.4226 13.6847 28.4314 13.6848 32.1109 11.5465L32.1019 14.7384C28.4224 16.8767 22.4135 16.8766 18.7063 14.7363C16.8426 13.6603 15.9118 12.2443 15.9158 10.8305Z"
        fill="#F9C73A"
      />
      <path
        d="M32.067 4.63468C35.7741 6.77501 35.7938 10.2556 32.1107 12.396C28.4312 14.5343 22.4223 14.5342 18.7151 12.3939C15.0116 10.2557 14.9919 6.77511 18.6714 4.63682C22.3545 2.4964 28.3634 2.49644 32.067 4.63468Z"
        fill="#F9C73A"
      />
      <path
        d="M37.6619 7.69822L37.6529 10.8901C37.6477 12.6981 36.46 14.5034 34.0874 15.8823C29.3116 18.6577 21.5405 18.6556 16.7334 15.8802C14.3143 14.4836 13.1062 12.6504 13.1113 10.8201L13.1204 7.62817C13.1152 9.45851 14.3234 11.2917 16.7424 12.6883C21.5495 15.4637 29.3206 15.4658 34.0964 12.6904C36.4691 11.3115 37.6568 9.50624 37.6619 7.69822Z"
        fill="#F2BC36"
      />
      <path
        d="M34.0402 2.63833C38.8473 5.41374 38.8726 9.91715 34.0966 12.6927C29.3208 15.468 21.5498 15.466 16.7426 12.6906C11.9355 9.91518 11.9101 5.41596 16.6859 2.64056C21.4619 -0.134943 29.2331 -0.137057 34.0402 2.63833ZM18.7154 11.5441C22.4226 13.6845 28.4314 13.6845 32.1109 11.5462C35.7941 9.40578 35.7744 5.92522 32.0672 3.78489C28.3637 1.64664 22.3548 1.6466 18.6717 3.78702C14.9921 5.92532 15.0118 9.40588 18.7154 11.5441Z"
        fill="#FED44C"
      />
      <path
        d="M18.8399 25.5814L15.6746 27.4241C14.9684 27.8351 14.1273 28.0085 13.1899 27.9251C12.5928 27.8737 11.9572 27.7132 11.2894 27.437C10.9299 27.2893 10.5639 27.1097 10.1915 26.8912C5.93475 24.4387 2.48695 18.4612 2.49979 13.5815C2.49979 13.5815 2.49979 13.5815 2.49979 13.5752V13.4019C2.52546 12.2526 2.74374 11.2767 3.11613 10.4807C3.28307 10.1339 3.47568 9.8192 3.70042 9.54332C4.00217 9.17088 4.35529 8.86239 4.75335 8.63134L7.91865 6.79517C7.52059 7.02622 7.16747 7.32812 6.86573 7.70683C6.64098 7.97644 6.44838 8.2912 6.28786 8.63792C5.90908 9.4339 5.69076 10.4164 5.67148 11.5591C5.67148 11.6168 5.66509 11.6748 5.66509 11.7391C5.65224 16.625 9.10004 22.5959 13.3568 25.055C13.7292 25.2669 14.1016 25.4466 14.4611 25.5946C15.1225 25.8704 15.7581 26.0309 16.3552 26.0886C17.2926 26.1723 18.1337 25.9924 18.8399 25.5814Z"
        fill="#FED44C"
      />
      <path
        d="M18.8417 25.5874L15.6741 27.4282C17.0591 26.6233 17.9191 24.9141 17.926 22.4875L21.0936 20.6467C21.0867 23.0733 20.2267 24.7825 18.8417 25.5874Z"
        fill="#F9C73A"
      />
      <path
        d="M4.75293 8.63526L7.92053 6.79446C9.32404 5.97882 11.2667 6.09208 13.408 7.32832L10.2404 9.16913C8.09915 7.93289 6.15645 7.81963 4.75293 8.63526Z"
        fill="#F9C73A"
      />
      <path
        d="M10.2405 9.16796L13.4081 7.32715C17.659 9.78143 21.1075 15.7543 21.0937 20.6439L17.9261 22.4847C17.9399 17.5951 14.4914 11.6222 10.2405 9.16796Z"
        fill="#F9C73A"
      />
      <path
        d="M10.9873 8.59785C15.2382 11.0521 18.6868 17.025 18.6729 21.9146C18.6591 26.7992 15.188 28.7771 10.9371 26.3228C6.68202 23.8662 3.2335 17.8933 3.24736 13.0086C3.26121 8.11911 6.73226 6.14121 10.9873 8.59785Z"
        fill="#F2BC36"
      />
      <path
        d="M10.2478 6.55112C15.7654 9.73671 20.2231 17.4626 20.2052 23.8029C20.1872 30.1429 15.7003 32.6998 10.1827 29.5142C4.6651 26.3286 0.203267 18.6052 0.221246 12.2652C0.239217 5.92487 4.7302 3.36553 10.2478 6.55112ZM10.1901 26.8953C14.4411 29.3495 17.9121 27.3717 17.926 22.487C17.9398 17.5975 14.4913 11.6246 10.2404 9.17029C5.98534 6.71364 2.51429 8.69153 2.50043 13.581C2.48658 18.4657 5.93509 24.4386 10.1901 26.8953Z"
        fill="#F9C73A"
      />
      <path
        d="M23.3758 21.9578C23.363 25.1104 22.2522 27.3253 20.4609 28.3655L17.2892 30.2082C19.0869 29.1614 20.1977 26.9466 20.2041 23.8006C20.2234 17.4572 15.7675 9.73318 10.2459 6.54863C7.47227 4.94351 4.9554 4.79585 3.13843 5.8489L6.30373 4.01241C8.1207 2.9531 10.6376 3.10075 13.4176 4.70588C18.9328 7.89042 23.3887 15.6144 23.3758 21.9578Z"
        fill="#FED44C"
      />
      <path
        d="M16.4136 26.5129L16.5945 27.1234L16.2201 26.6084L15.5501 27.8429L15.7692 26.4555L15.1587 26.6365L15.6737 26.262L14.4392 25.5921L15.8266 25.8112L15.6456 25.2007L16.0201 25.7157L16.69 24.4812L16.4709 25.8686L17.0814 25.6876L16.5664 26.0621L17.8009 26.732L16.4136 26.5129Z"
        fill="white"
      />
      <path
        d="M31.974 6.40089L32.3095 7.53247L31.6154 6.5779L30.3735 8.86618L30.7797 6.29453L29.6482 6.63001L30.6027 5.93585L28.3145 4.69409L30.8861 5.1002L30.5506 3.96872L31.2447 4.92318L32.4865 2.63501L32.0804 5.20656L33.2119 4.87118L32.2574 5.56523L34.5456 6.8071L31.974 6.40089Z"
        fill="white"
      />
    </svg>
  );
}

export default CoinsIcon;
